import { useMemo } from 'react'

import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react'

import { ABCDTestVariants, GROWTHBOOK_EXPERIMENT } from 'root-constants'

export const useABTest = () => {
  const isPrimerActive = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_27)
  const isChinPageSetVariantBActive = useFeatureIsOn(
    GROWTHBOOK_EXPERIMENT.LV_1113,
  )
  const isIntroFastCoralThemeActive = false
  const isPrimerFormActive = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_804)
  const isCoachingUpsellActive = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_1274)

  const isCoachingUpsellContentActive = useFeatureIsOn(
    GROWTHBOOK_EXPERIMENT.LV_1327,
  )

  const isIntroSaleSoldOutTest = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_1326)
  const isLuvlyRefHighPricesActive = useFeatureIsOn(
    GROWTHBOOK_EXPERIMENT.LV_1325,
  )
  const isSpecialCancelOfferActive = useFeatureIsOn(
    GROWTHBOOK_EXPERIMENT.LV_1338,
  )
  const isLuvlyIntroFastNewPaywallActive = useFeatureIsOn(
    GROWTHBOOK_EXPERIMENT.LV_1361,
  )
  const isLuvlyDisclaimerCancelActive = useFeatureIsOn(
    GROWTHBOOK_EXPERIMENT.LV_1468,
  )
  const isHigherIntroRef4Active = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_1410)
  const isEmailPopupsTestActive = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_1415)
  const isFunellabCohortActive = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_1493)
  const isRef6NewPricingActive = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_1529)
  const isArVisualsActive = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_1642)
  const isRef03NewPricingActive = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_1528)
  const isHolidayActive = useFeatureIsOn(GROWTHBOOK_EXPERIMENT.LV_1725)

  const isArefDynamicHeadersActive = useFeatureIsOn(
    GROWTHBOOK_EXPERIMENT.LV_1618,
  )

  const ref03AgePagesTestVariant = useFeatureValue(
    GROWTHBOOK_EXPERIMENT.LV_1690,
    ABCDTestVariants.VARIANT_A,
  )
  const isRef03AgePagesTestActive = useMemo(() => {
    return (
      ref03AgePagesTestVariant === ABCDTestVariants.VARIANT_B ||
      ref03AgePagesTestVariant === ABCDTestVariants.VARIANT_C
    )
  }, [ref03AgePagesTestVariant])

  const isIntro4SaleHighPricesActive = useFeatureIsOn(
    GROWTHBOOK_EXPERIMENT.LV_1656,
  )

  return {
    isPrimerActive,
    isChinPageSetVariantBActive,
    isIntroFastCoralThemeActive,
    isPrimerFormActive,
    isCoachingUpsellActive,
    isCoachingUpsellContentActive,
    isLuvlyRefHighPricesActive,
    isIntroSaleSoldOutTest,
    isSpecialCancelOfferActive,
    isLuvlyIntroFastNewPaywallActive,
    isLuvlyDisclaimerCancelActive,
    isHigherIntroRef4Active,
    isEmailPopupsTestActive,
    isFunellabCohortActive,
    isRef6NewPricingActive,
    isArVisualsActive,
    isRef03NewPricingActive,
    isArefDynamicHeadersActive,
    isRef03AgePagesTestActive,
    ref03AgePagesTestVariant,
    isIntro4SaleHighPricesActive,
    isHolidayActive,
  }
}
